import React from 'react';

const LoadingSpinner = () => (
    <div className="loading-container">
        <div className="loading-spinner"></div>
        <p>Loading...</p>
    </div>
);

export default LoadingSpinner;
